<template>
  <mdb-select
    outline
    search
    class="no-margin-select mt-3"
    label="Client"
    :visible-options="20"
    :disabled="disabled"
    v-model="clientsModel"
    @getValue="clientSelected($event)"
  />
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { mdbSelect } from 'mdbvue'
import {OrderTypes} from '../enums'
import {orderType} from '../utils'

export default {
  name: 'CalcControlsClientSelect',
  data () {
    return {
      clientsModel: []
    }
  },
  computed: {
    ...mapState('calc', {
      clients: state => state.data.clients,
      client: state => state.query.client,
      linked: state => state.linked,
      clone: state => state.clone
    }),
    ...mapState('user', {user: state => state.user}),
    disabled: function () {
      return (this.clone && this.clone.context === OrderTypes.CLIENT) ||
        (this.linked && orderType(this.linked) === OrderTypes.CLIENT) ||
        (this.user && !!this.user.client)
    }
  },
  methods: {
    ...mapActions('calc', ['setClient']),
    calculateModel () {
      const clientsModel = [
        {text: 'Net Rate', value: null, selected: this.client === null},
        ...this.clients.map(cl => {
          return {text: cl, value: cl, selected: cl === this.client}
        })
      ]
      this.clientsModel = clientsModel
    },
    clientSelected (client) {
      if (client === null && this.user && this.user.client) {
        client = this.user.client
      }
      this.setClient(client)
    }
  },
  mounted () {
    this.$bus.$on('profile-fetch-completed', () => {
      if (this.user && this.user.client) {
        this.setClient(this.user.client).then(() => {
          this.calculateModel()
        })
      }
    })
    this.calculateModel()
  },
  watch: {
    client: {
      handler: function (newValue) {
        this.calculateModel()
      }
    },
    clients: {
      deep: true,
      handler: function () {
        this.calculateModel()
      }
    }
  },
  components: {
    mdbSelect
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CalcControlsClientSelect.vue